module.exports = __webpack_public_path__ + "img/width_2.76a457f4.png";